
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from '../../backend.service';
import { ApplicationService } from '../../application/application.service';
import { CustomerCommsEmail, CustomerCommsPhone } from './email-mobile';

@Injectable()
export class EmailMobileService {

  private emailUrl = '/Comms/customers/{customerId}/EmailAddress';
  private mobileUrl = '/Comms/customers/{customerId}/MobilePhone';
  private verifyOtpUrl = '/Comms/customers/{customerId}/MobilePhone/Verification';
  private checkMobileUniqueUrl = '/Comms/MobilePhone/{mobileNumber}/Exists';

  constructor(private backendService: BackendService, private applicationService: ApplicationService) { }

  getEmail(): Observable<CustomerCommsEmail> {
    return this.backendService.getData(this.emailUrl);
  }
  getMobile(): Observable<CustomerCommsPhone> {
    return this.backendService.getData(this.mobileUrl);
  }
  saveMobile(phone: string) {
    const mobileData = {
      'PhoneNumber': phone,
      'TrustedMerchantId': this.applicationService.getMerchantId()
    };
    return this.backendService.putData(this.mobileUrl, mobileData);
  }
  resendOtp(phone: string) {
    return this.saveMobile('91' + phone);
  }
  verifyOtp(verificationCode: string) {
    return this.backendService.setData(this.verifyOtpUrl, { 'Code': verificationCode });
  }
  checkMobileUnique(mobileNumber: string, customerId: string = null): Observable<any> {
    let url = this.checkMobileUniqueUrl;
    if (customerId && customerId.length > 0) {
      url += '?customerId=' + customerId;
    }
    return this.backendService.getData(url.replace('{mobileNumber}', mobileNumber));
  }
}
